import { type CSSProperties } from 'react';

type LogoProps = {
    style?: CSSProperties;
};

export function Logo({ style }: LogoProps) {
    return (
        <svg
            style={style}
            width="220"
            height="24"
            fill="none"
            viewBox="0 0 220 24"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#a)">
                <mask
                    id="b"
                    width="220"
                    height="24"
                    x="0"
                    y="0"
                    maskUnits="userSpaceOnUse"
                    style={{ maskType: 'luminance' }}
                >
                    <path fill="#fff" d="M220 0H0v24h220z" />
                </mask>
                <g mask="url(#b)">
                    <path
                        fill="#fff"
                        d="M37.203.063H34.12a.476.476 0 0 0-.474.473v5.765a.364.364 0 0 1-.6.277C31.77 5.493 30.332 5.09 28.554 5.09c-1.155 0-2.275.272-3.303.728-3.332 1.483-5.272 4.668-5.272 8.269 0 4.784 3.666 8.933 8.575 8.933 1.743 0 3.62-.589 4.833-1.852a.34.34 0 0 1 .565.11v.738c0 .254.203.456.456.456h2.807a.453.453 0 0 0 .456-.456V.536a.467.467 0 0 0-.468-.473m-8.343 18.9c-2.876 0-5.59-2.09-5.59-4.94s2.778-4.877 5.624-4.877c2.91 0 5.497 2.031 5.497 4.877-.006 2.908-2.558 4.94-5.531 4.94M8.996 5.088C4.025 5.09.023 9.146.023 14.086c0 4.905 4.065 8.933 8.973 8.933 5.093 0 8.91-3.907 8.91-8.996 0-4.934-3.938-8.934-8.91-8.934m0 13.873c-2.875 0-5.589-2.089-5.589-4.934S6.19 9.152 9.031 9.152c2.91 0 5.497 2.031 5.497 4.876-.006 2.909-2.558 4.934-5.532 4.934M57.31 5.695h-2.806a.453.453 0 0 0-.457.456v.739a.337.337 0 0 1-.565.11c-1.213-1.264-3.09-1.853-4.833-1.853-4.903 0-8.575 4.15-8.575 8.933 0 4.784 3.667 8.933 8.575 8.933 1.743 0 3.62-.589 4.833-1.852a.34.34 0 0 1 .565.11v.738c0 .254.203.456.457.456h2.806a.453.453 0 0 0 .456-.456V6.151a.453.453 0 0 0-.456-.456m-8.361 13.267c-2.876 0-5.59-2.089-5.59-4.94 0-2.85 2.778-4.876 5.625-4.876 2.91 0 5.497 2.031 5.497 4.877 0 2.908-2.558 4.94-5.532 4.94M69.926.114v23.772h-1V.114z"
                    />
                    <mask
                        id="c"
                        width="152"
                        height="39"
                        x="74"
                        y="-6"
                        maskUnits="userSpaceOnUse"
                        style={{ maskType: 'luminance' }}
                    >
                        <path
                            fill="#fff"
                            d="M225.914-5.57H74.812v37.68h151.102z"
                        />
                    </mask>
                    <g mask="url(#c)">
                        <mask
                            id="d"
                            width="139"
                            height="22"
                            x="81"
                            y="2"
                            maskUnits="userSpaceOnUse"
                            style={{ maskType: 'luminance' }}
                        >
                            <path
                                fill="#fff"
                                d="M219.637 2.994H81.103v20.444h138.534z"
                            />
                        </mask>
                        <g fill="#fff" mask="url(#d)">
                            <path d="M127.095 10.383q-.516-1.261-1.289-2.126a5.7 5.7 0 0 0-2.2-1.52q-1.3-.51-3.017-.51-2.352 0-4.165 1.119-1.813 1.12-2.808 3.094-.997 1.975-.997 4.434 0 2.457.968 4.406.969 1.95 2.741 3.053 1.77 1.105 4.095 1.105 2.63 0 4.347-1.174 1.565-1.073 2.325-3.009v3.63h6.392V6.917h-6.392zm-1.84 7.613q-.9.495-2.091.496c-.794 0-1.434-.161-2.034-.484a3.4 3.4 0 0 1-1.384-1.326q-.485-.843-.485-1.947t.485-1.947q.484-.843 1.384-1.312t2.09-.47 2.075.455q.885.458 1.37 1.298.484.843.484 1.92c0 .72-.166 1.392-.497 1.962a3.6 3.6 0 0 1-1.397 1.355M165.747 7.069q-1.494-.843-3.654-.842-1.993 0-3.307.65-1.315.648-2.061 1.685a9.2 9.2 0 0 0-1.108 2.065V2.994h-6.366v19.891h6.366v-7.652q0-1.27.401-2.168.4-.897 1.189-1.34.79-.442 1.925-.442 1.05 0 1.758.429.705.429 1.066 1.3.36.87.36 2.14v7.736h6.422v-9.089q-.001-2.54-.748-4.213-.747-1.67-2.241-2.513zM184.821 7.179q-2.022-.952-5.009-.952c-1.993 0-3.788.355-5.273 1.064q-2.23 1.063-3.404 2.956-1.177 1.893-1.177 4.352c0 1.64.429 3.242 1.287 4.587q1.287 2.017 3.709 3.136t5.715 1.12q2.215 0 4.248-.553 2.033-.552 3.39-1.464v-4.587q-1.33.857-2.797 1.285-1.465.429-3.238.429-1.992 0-3.389-.497-1.398-.497-2.104-1.465a3.6 3.6 0 0 1-.37-.635h12.451v-1.823q-.001-2.459-1.01-4.227t-3.031-2.722zm-6.864 3.937q.884-.414 2.16-.415 1.162 0 1.979.36t1.231 1.05q.258.43.357.967h-7.387q.112-.402.319-.76.456-.788 1.343-1.202zM218.945 9.404q-.692-1.574-2.035-2.376-1.341-.801-3.335-.801-2.629 0-4.179 1.395-1.121 1.011-1.706 2.853-.449-1.721-1.518-2.77-1.508-1.477-4.055-1.477c-1.697 0-3.131.48-4.137 1.436q-1.023.976-1.619 2.737V6.92h-6.337v15.968h6.366v-7.763q0-1.16.331-2.017.334-.855.955-1.34.623-.483 1.479-.484 1.246 0 1.869.856.623.857.623 2.376v8.372h6.365V14.79q0-1.049.305-1.85t.913-1.23q.608-.43 1.523-.43 1.246 0 1.869.912.622.91.622 2.597v8.095h6.393v-9.558q0-2.348-.692-3.923M145.981 17.966q-.79 0-1.192-.456-.376-.429-.398-1.189V11.53h3.603V6.917h-3.603V2.994h-6.393v3.923h-3.235v4.614h3.235v6.363q0 1.706.816 2.972a5.2 5.2 0 0 0 2.195 1.92q.284.133.576.236 1.124.406 2.39.408 1.087 0 2.197-.294a7 7 0 0 0 1.003-.346 5 5 0 0 0 .82-.445v-5.55q-.83 1.168-2.013 1.168zM100.569 2.994l-4.432 12.403-4.432-12.403H81.103v19.891h6.338V8.222l5.326 14.663h6.74l5.327-14.663v14.663h6.339V2.995z" />
                        </g>
                    </g>
                </g>
            </g>
            <defs>
                <clipPath id="a">
                    <path fill="#fff" d="M0 0h220v24H0z" />
                </clipPath>
            </defs>
        </svg>
    );
}
